module.exports = __webpack_public_path__ + "images/bbe15039b51eff9fc693b95669ce5a83a7195bd8fe9943dda8c24ddc4dc70647.svg";